import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import CreateUserForm from '../../../features/dealer/user/components/CreateUserForm';

export default function CreateUserPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Create User')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<CreateUserForm />
			</div>
		</React.Fragment>
	)
} 
